type TExplanation = { languageCode: string; hasExplanation: boolean };

// Extract non-Japanese language codes that have explanations
export const mapExplanationsToLanguages = (explanations?: TExplanation[]): string[] => {
  return (explanations ?? []).filter((e) => e.hasExplanation && e.languageCode !== "ja").map((e) => e.languageCode.toUpperCase());
};
